export default {
    headerLabel: 'E-mail verification',
    verifyingEmail: 'Verifying e-mail',
    emailVerifySuccess: 'Your e-mail has been verified!',
    emailVerifyFailure:
        'Something went wrong... try again later or contact support',
    gotoMyPage: 'Go back to My Page',
};
